import React, { useRef } from 'react';
import { Button, Container} from 'reactstrap';
import { toast } from "react-toastify";
import {
  AiOutlinePhone,
  AiFillMail,
  AiOutlinePushpin,
  AiOutlineWhatsApp,
} from "react-icons/ai";
import emailjs from "@emailjs/browser";
const Contact = () => {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_cssr0ws",
        "template_z0557hg",
        form.current,
        "gbP5bjJ3NjMYgzGkO"
      )
      .then(
        (result) => {
          console.log(result.text);
          toast.success(
            " Email send successfully 📧 we'll get back to you   ",
            {
              position: toast.POSITION.TOP_CENTER,
            }
          );
        },
        (error) => {
          console.log(error.text);
        }
    );
    e.target.reset();
  }; 
  
    // const notify = () => {
       
    //     toast.error("Sorry Email 📧  Services unavailable 🥺 ", {
    //       position: toast.POSITION.TOP_CENTER,
    //     });
    // }

    return (
      <Container>
        <div id="contact" classNameName="container-fluid bg-grey text-center ">
          <h2 classNameName="text-center">CONTACT</h2>
          <div className="row">
            <div className="col-sm-5">
              <p>Contact us and we'll get back to you within 24 hours.</p>
              <p>
                <span className="glyphicon glyphicon-map-marker"></span>
                <AiOutlinePushpin /> Gopali Chowck Arrah,Bihar India
              </p>
              <p>
                <span className="glyphicon glyphicon-phone"></span>
                <AiOutlinePhone /> +91-9534531830
                <br />
                <AiOutlineWhatsApp /> +91-7903303582
              </p>
              <p>
                <span className="glyphicon glyphicon-envelope"></span>{" "}
                <AiFillMail /> capcorner121@gmail.com
              </p>
            </div>
            <form ref={form} onSubmit={sendEmail}>
              <div className="col-sm-7 slideanim">
                <div className="row">
                  <div className="col-sm-6 form-group">
                    <input
                      className="form-control"
                      id="name"
                      name="user_name"
                      placeholder="Name"
                      type="text"
                      required
                    />
                  </div>
                  <div className="col-sm-6 form-group">
                    <input
                      className="form-control"
                      id="email"
                      name="user_email"
                      placeholder="Enter Your Email"
                      type="email"
                      required
                    />
                  </div>
                </div>
                <div className="col-sm-6 form-group">
                  <input
                    className="form-control"
                    id="sunject"
                    name="subject"
                    placeholder="Subject"
                    type="text"
                    required
                  />
                </div>
                <textarea
                  className="form-control"
                  id="message"
                  name="message"
                  placeholder="Comment"
                  type="text"
                  rows="5"
                  required
                ></textarea>
                <br />
                <div className="row">
                  <div className="col-sm-12 form-group">
                    <div>
                      <Button color="danger" type="submit">
                        Send
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Container>
    );
}

export default Contact;